import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16 } from '@onefootprint/icons';
import { IconButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'usehooks-ts';
import useSession from '@/hooks/use-session';
const FingerprintAnnouncement = () => {
  const $ = _c(23);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "deviceInsights.fingerprintAnnouncement"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  const {
    data
  } = useSession();
  const [isSeen, setIsSeen] = useLocalStorage(`deviceInsightsFingerprintSeen:${data.user?.id}`, false);
  if (isSeen) {
    return null;
  }
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== setIsSeen) {
    t3 = () => setIsSeen(true);
    $[5] = setIsSeen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <IconButton aria-label={t2} icon={IcoCloseSmall16} color="tertiary" size="tiny" variant="ghost" className="absolute top-3 right-3" onClick={t3} />;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t(_temp3);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <p className="text-label-2 text-primary">{t5}</p>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t(_temp4);
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <p className="text-body-2 text-tertiary">{t7}</p>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t1 || $[19] !== t4 || $[20] !== t6 || $[21] !== t8) {
    t9 = <section aria-label={t1} className="relative flex flex-col gap-1 p-4 pr-12 border border-solid rounded-default border-tertiary bg-primary shadow-sm">{t4}{t6}{t8}</section>;
    $[18] = t1;
    $[19] = t4;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default FingerprintAnnouncement;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.dismiss;
}
function _temp3($_1) {
  return $_1.title;
}
function _temp4($_2) {
  return $_2.description;
}